import { render, staticRenderFns } from "./MyWiki.vue?vue&type=template&id=e1f0c124&scoped=true&"
import script from "./MyWiki.vue?vue&type=script&lang=js&"
export * from "./MyWiki.vue?vue&type=script&lang=js&"
import style0 from "./MyWiki.vue?vue&type=style&index=0&id=e1f0c124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f0c124",
  null
  
)

export default component.exports